import React, { createContext, useState, ReactNode, FC, useEffect } from 'react';
import { getUserDetailsByMailId } from '../fiscalUpgrade/services/Users/user-Info.service';

interface Role {
  createdBy: string;
  createdTime: string;
  lastUpdatedBy: string;
  lastUpdatedTime: string;
  roleId: number;
  roleName: string;
}

interface UserParticipantXref {
  participantId: number;
  participantName: string;
}

interface UserVO {
  aadReferenceId: string;
  clientId: number;
  createdBy: string;
  createdTime: string;
  defaultParticipantId: number;
  firstName: string;
  isActive: string;
  lastName: string;
  lastUpdatedBy: string;
  lastUpdatedTime: string;
  mailId: string;
  middleName?: string;
  roles: Role;
  userId: number;
  userParticipantXref: UserParticipantXref[];
  version: number;
}

export const UserContext = createContext<any>(undefined);

interface UserProviderProps {
  children: ReactNode;
}

export const UserProvider: FC<UserProviderProps> = ({ children }) => {
  const [userDetails, setUserDetails] = useState<UserVO[]>(() => {
    // Retrieve stored userDetails from localStorage on initialization
    const storedData = localStorage.getItem('userDetails');
    return storedData ? JSON.parse(storedData) : [];
  });

  // Update localStorage whenever userDetails changes
  useEffect(() => {
    localStorage.setItem('userDetails', JSON.stringify(userDetails));
  }, [userDetails]);

  const getUserDetailsById = async (emailId: string): Promise<void> => {
    try {
      const response: any = await getUserDetailsByMailId(emailId);
      if (response) {
        setUserDetails(response?.data);
      } else {
        setUserDetails([]);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      setUserDetails([]);
    }
  };

  const updateUserDetails = (newDetails: UserVO): void => {
    setUserDetails((prevDetails) => [...prevDetails, newDetails]);
  };

  const resetUserDetails = (): void => {
    setUserDetails([]);
    localStorage.removeItem('userDetails'); // Clear localStorage when resetting
  };

  return (
    <UserContext.Provider
      value={{ userDetails, setUserDetails, getUserDetailsById, updateUserDetails, resetUserDetails }}
    >
      {children}
    </UserContext.Provider>
  );
};
